import summaryMissedHours from './components/summaryMissedHours.vue';


export default {
  routes: [
    {
      path: '/',
      component:summaryMissedHours,
      name:'summaryMissedHours'
    },

  ]
};
